// D-0097 (Rafael 24/10): "Voltar para a 1ª aba" do Custo Previsto (Aprovados pelo Financeiro →
// Planos de Pagamento). A regra de quem pode voltar mora na API (VoltaParaPlanos) e chega pronta
// em `motivo_nao_volta`; aqui só se lê. Camada 1 da validação: aviso + ação desabilitada.

export const MOTIVO_VOLTA_MAX = 1000;

// Por que a linha NÃO pode voltar (null = pode). Campo ausente (API antiga) não bloqueia: a API
// recusa do mesmo jeito.
export function motivoNaoVolta(item) {
    if (!item || item._tipo !== 'previsao') return 'Só previsão de fornecedor volta para Planos de Pagamento.';
    return item.motivo_nao_volta || null;
}

// Erro do motivo digitado (null = válido). Espelha VoltaParaPlanos::erroMotivo.
export function erroMotivoVolta(texto) {
    const t = (texto || '').trim();
    if (!t) return 'Informe o motivo da volta: ele vai para o operador do evento.';
    if (t.length > MOTIVO_VOLTA_MAX) return 'O motivo passou de ' + MOTIVO_VOLTA_MAX + ' caracteres.';
    return null;
}
